<template>
  <hg-deal-card
    v-if="
      deal.__typename === 'DirectDeal' ||
      ($i18n.locale === 'de' && deal.__typename === 'AmadeusPackageTourDeal')
    "
    :type-label="$t(deal.__typename)"
    :title="deal.title"
    :subtitle="deal.subtitle"
    :expiry-date="deal.expiryDate"
    :image="deal.featuredImage"
    :price="deal.price"
    :badge="deal.badge"
    :bookmark="deal.bookmark"
    show-buttons
    tag="a"
    :target="deal.price ? '_blank' : ''"
    rel="nofollow"
    :href="deal.price ? deal.price.url : getLocalePath()"
    @onClickBookmark="clickBookmark(deal)"
    @onClickShare="clickShare(deal)"
    @onClick="pushDataLayer(deal)"
  />
  <hg-deal-card
    v-else
    :type-label="$t(deal.__typename)"
    :title="deal.title"
    :subtitle="deal.subtitle"
    :expiry-date="deal.expiryDate"
    :image="deal.featuredImage"
    :price="deal.price"
    :badge="deal.badge"
    :bookmark="deal.bookmark"
    tag="nuxt-link"
    :to="getLocalePath()"
    show-buttons
    @onClickBookmark="clickBookmark(deal)"
    @onClickShare="clickShare(deal)"
    @onClick="pushDataLayer(deal)"
  />
</template>

<script>
import DealCardMixin from '@/mixins/DealCardMixin';
import DealPathName from '@/mixins/DealPathName';
import GtmEventsMixin from '@/mixins/GtmEventsMixin';

export default {
  mixins: [DealCardMixin, DealPathName, GtmEventsMixin],
  props: {
    deal: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getLocalePath() {
      return (
        this.localePath({
          name: this.getDealPathName(this.deal.__typename),
          params: { slug: this.deal.slug },
        }) + this.debugParams
      );
    },
    pushDataLayer(deal) {
      this.$gtm.push({
        event: 'click_to_deal',
        uId: deal.id, //oder
        deal_name: deal.title,
      });
    },
  },
};
</script>
